import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ShareSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.35587 22.25H17.644C19.6323 22.25 20.6309 21.2436 20.6309 19.289V9.37629C20.6309 7.41781 19.6323 6.41525 17.644 6.41525H14.8786V7.81336H17.6189C18.6411 7.81336 19.2376 8.37222 19.2376 9.44462V19.2207C19.2376 20.3017 18.6411 20.848 17.6189 20.848H6.38095C5.33452 20.848 4.76222 20.3017 4.76222 19.2207V9.44462C4.76222 8.37222 5.33452 7.81336 6.38095 7.81336H9.12897V6.41525H6.35587C4.37622 6.41525 3.3689 7.41005 3.3689 9.37629V19.289C3.3689 21.2513 4.37622 22.25 6.35587 22.25ZM11.9956 14.625C12.3718 14.625 12.6922 14.3132 12.6922 13.9456V3.61522L12.6365 2.16135L13.404 2.96731L14.9851 4.6263C15.1131 4.76294 15.2921 4.83514 15.4586 4.83514C15.8184 4.83514 16.0956 4.57526 16.0956 4.22888C16.0956 4.03644 16.0186 3.90367 15.8819 3.77568L12.4959 0.480946C12.3247 0.309694 12.1794 0.25 11.9956 0.25C11.8204 0.25 11.6713 0.309694 11.4953 0.480946L8.10536 3.77568C7.97734 3.90367 7.90037 4.03644 7.90037 4.22888C7.90037 4.57526 8.16503 4.83514 8.52871 4.83514C8.69522 4.83514 8.88287 4.76294 9.00699 4.6263L10.592 2.96731L11.3634 2.15747L11.3076 3.61522V13.9456C11.3076 14.3132 11.628 14.625 11.9956 14.625Z"
        fill={color}
      />
    </svg>
  );
};

export { ShareSvg };
